
export const menuItems = {
    
    company: [
        { url: "/about", label: "About Us" },
        { url: "/how-products-work", label: "Introduction to Products and Services" },
        { url: "/team", label: "Team" },
        { url: "/invest", label: "Invest" },
        { url: "/press", label: "Press" },
        { url: "/contact", label: "Contact Us" },
    ],

    faq: [
        { url: "/faq#what-makes-lonch-different", label: "What Makes Lonch Different?"  },
        { url: "/faq#market-comparison", label: "Market Comparison"  },
        { url: "/faq#direction", label: "Direction"  }
    ],

    legal: [
        // { url: "/terms-of-service", icon: "clipboard check", label: "Terms Of Service" },
        { url: "/about#privacy", icon: "user secret", label: "Privacy Policy" },
        { url: "/licenses", icon: "briefcase", label: "Licenses" },
    ]
}


// WEBPACK FOOTER //
// ./src/common/MenuItems.tsx